module.exports = __webpack_public_path__ + "static/media/ico-tus-contactos-act.380a43a6.svg";